export default function handleActiveLink(router, slug, styles) {
  if (router.asPath === slug) return styles._active;
  else return "";
}
